
import React, { useContext } from 'react';
import TitleBar from '../../comonents/TitleBar';
import BtnShow from '../../comonents/Buttons';
import './index.css'

import { useNavigate, useParams } from 'react-router-dom';
import axios from '../../axios'
import ErrorModal from '../../comonents/ErrorModal';
import { EXPRESS_SERVER_URL, MIN_MINER_COUNT } from "../../config";

// import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie'
import { Context } from '../../context/Context'
// import { EXPRESS_SERVER_URL, COOKIES_EXPIRES_TIME } from "../../config";
// import axios from '../../axios'
import copy from 'copy-to-clipboard';
import Cookies from 'js-cookie'

export default function Game2BlockDetail() {
    const navigate = useNavigate();
    let { bid } = useParams();
    bid = bid || 0;

    const [block, setBlock] = React.useState({});
    const { sessionID } = useContext(Context);

    let monthNames = ["Jan", "Feb", "Mar", "Apr",
        "May", "Jun", "Jul", "Aug",
        "Sep", "Oct", "Nov", "Dec"];

    React.useEffect(() => {
        getBlocks();
    }, []);

    const getBlocks = async () => {
        try {
            const result = await axios(`${EXPRESS_SERVER_URL}/game2/session/sid/${sessionID}`, { method: 'GET' })
            const json = await result.data;
            if (json.status === 0) {
                setBlock(json.session.blocks[bid]);
            }
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <div  >

            <TitleBar backLastPage="" lastPageName="" />

            <div style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '1rem' }}>
                <div className='text-center'>
                    <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '30px', paddingBottom: '1rem', fontWeight: 'bold' }}>Block Details</p></b>
                </div>

            </div>

            <div className='Block_Details'>
                <div className='text-center h3' style={{ margin: '1rem' }} > Block{bid}(FourData)</div>

                {
                    block.datas ? block.datas.map(data => {
                        var date
                        var dateStr

                        if (data.dd) {
                            date = new Date(data.dd.substring(0, 19) + "-08:00");
                            dateStr = `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`
                        }
                        return (
                            <div className="row" key={data.did}>
                                <div className="col-md-3 BlockText text-center">
                                    Data {data.did}
                                </div>
                                <div className="col-md-9 Block_detail">
                                    <div className="d-flex justify-content-between">
                                        <div>Customer ID:</div> <div> {data.cid}</div>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div>Product ID:</div> <div> {data.pid}</div>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div>Product Quantity:</div> <div> {data.pq}</div>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div>Product Name:</div> <div> {data.pn}</div>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div>Delivery Date:</div> <div> {dateStr}</div>
                                    </div>

                                </div>
                            </div>
                        )
                    }) : null
                }

            </div>

            <div className='Btns_Back'>
                <input type="button" className='Btn_Back' value='Back' onClick={e => navigate(-1)}></input>
            </div>
            <br />


        </div>
    )
}